import { NameAndMobileOnlyOptions } from "./NameAndMobileOnlyOptions";
import { USALandingOptions } from "./USALandingOptions";
import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate23: LandingPageConfigOptions = {
  ...NameAndMobileOnlyOptions,
  showsStoreSelector: true,
  ...USALandingOptions,
};
